export default __webpack_public_path__ + "static/media/icon-crown.6ad791c7.svg";